// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__k8qA3","item":"Item_item__3SHgj","label":"Item_label__2vUpP","arrow":"Item_arrow__1t8iQ"};